<app-list-filter-controls
  [includeFilterButton]="false"
  [includeSortByControl]="false"
  [breakControlsIntoMultipleLines]="true"
  [searchPlaceholder]="'sharedFeatures.SearchUser' | translate"
  (searchValue)="onSearch($event)"
>
  <ng-container slot="dropdown">
    <div class="dropdown__container__item px-4 my-1">
      <app-dropdown-menu
        [selectedValue]="userStatus.All"
        [dropdownText]="'Users.StatusPrefix' | translate"
        [dropdownValue]="userStatus | enumToArray "
        [iconName]="'user'"
        (selectedValueChange)="onSelectStatus($event.value)"
        [labelTranslationKey]="'sharedFeatures.UserStatus'"
      ></app-dropdown-menu>
    </div>
  </ng-container>
</app-list-filter-controls>

<app-entity-listing
  [totalCount]="totalRowsCount"
  [state]="sectionState"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [emptyStateMainLabel]="'Users.EmptyStateMainLabel' | translate"
  [emptyStateSubLabel]="'Users.EmptyStateSubLabel' | translate"
  [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate"
  (pageIndexChanged)="onPageIndexChange($event)"
>
  <div class="table scrollable scrollable--x">
    <table mat-table [dataSource]="dataSource" matSort matSortDirection="asc">
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef class="code-col-width">{{ "Users.Table.GeneratedCode" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.code }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="col-width">{{ "Users.Table.Name" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <div class="media-container flex row">
            <div class="img-container" *ngIf="false">
              <img
                class="img"
                [src]="
                          element.img_path
                            ? element.img_path
                            : 'assets/images/shipment-control.svg'
                        "
              />
            </div>
            <div class="text-container">{{ element.name }}</div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="col-width">{{ "Users.Table.Email" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.email || "_______" }}</td>
      </ng-container>

      <ng-container matColumnDef="mobileNumber">
        <th mat-header-cell *matHeaderCellDef class="col-width">{{ "Users.Table.MobileNumber" | translate }}</th>
        <td mat-cell *matCellDef="let element" [class.rtl]="layoutService.websiteDirection$.value === 'rtl'">{{ element.mobileNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef class="roles-width">{{ "Users.Table.Privilege" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngFor="let role of element.roles; let i = index">
            <div *ngIf="i < 3" class="role">
              <div class="roles-limited-text">{{ 'Enum.Roles.' + role.name | translate}}</div>

              <div *ngIf="i == 2 && element.roles.length - 3 > 0" class="roles-count">+ {{ element.roles.length - 3 }}</div>
            </div>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef [hidden]="true"></th>
        <td mat-cell *matCellDef="let element" [hidden]="true">{{ element.updatedAt }}</td>
      </ng-container>

      <ng-container matColumnDef="shippingType">
        <th mat-header-cell *matHeaderCellDef class="col-width" [hidden]="userType !== UserType.CUSTOMER">{{ "Inputs.ShippingType" | translate }}</th>
        <td mat-cell *matCellDef="let element" [hidden]=" userType !== UserType.CUSTOMER">
          {{ ("Enum.ShippingType." + element.shippingType | translate) || "_____" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="allowToLogin">
        <th mat-header-cell *matHeaderCellDef class="col-width" [hidden]="userType !== UserType.CUSTOMER">{{ "Inputs.AllowToLogin" | translate }}</th>
        <td mat-cell *matCellDef="let element" [hidden]=" userType !== UserType.CUSTOMER">
          <span [ngClass]="element.allowToLogin ? 'text-success' : 'text-warn'">
            {{ element.allowToLogin ? ("General.Allowed" | translate) : ("General.NotAllowed" | translate) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="col-width">{{ "Users.Table.Status" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <app-status-label [value]="element.status"></app-status-label>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th class="center column-sticky" mat-header-cell *matHeaderCellDef></th>

        <td
          app-click-stop-propagation
          [matMenuTriggerFor]="menu"
          class="center action column-sticky"
          app-click-stop-propagation
          mat-cell
          *matCellDef="let element"
        >
          <div class="flex justify-center align-center">
            <div class="flex justify-center">
              <app-icon name="menu-vert" class="cursor-pointer text-700"></app-icon>
            </div>

            <mat-menu class="item-actions" #menu>
              <!-- view action -->
              <mat-option (click)="showDetails.emit(element.id)">
                <span>{{ "Buttons.Details" | translate }}</span>
              </mat-option>

              <mat-option
                (click)="onApproveUserClicked(element)"
                *ngIf="!readonly && (RolesConstants.APPROVE_USERS | userRoleChecker)
                && element.status !== userStatus.ACTIVE && element.isVerified
                &&(userType == UserType.CUSTOMER || userType == UserType.FLEET || userType === UserType.ORGANIZATION)"
              >
                <span>{{ "Buttons.Approve" | translate }}</span>
              </mat-option>

              <mat-option
                (click)="onActivateResetPasswordOptionClicked(element.id)"
                *ngIf="
                !readonly &&
                (RolesConstants.PASSWORD_ACTION | userRoleChecker)&&
                 ((!userType)||
                 ((userType === UserType.CUSTOMER || userType === UserType.FLEET || userType === UserType.ORGANIZATION)))"
              >
                <span>{{ "Buttons.Activate" | translate }}</span>
              </mat-option>

              <mat-option
                *ngIf="!readonly &&
                (RolesConstants.PASSWORD_ACTION | userRoleChecker)&& element.status === userStatus.ACTIVE && element.isVerified"
                (click)="onResetPasswordOptionClicked(element)"
              >
                <span>{{ "Buttons.ResetPassword" | translate }}</span>
              </mat-option>

              <mat-option
                (click)="openGenerateComplexPassword(element.id)"
                *ngIf="!readonly &&
                (RolesConstants.PASSWORD_ACTION | userRoleChecker)"
              >
                <span>{{ "sharedFeatures.usersList.button.generateComplexPassword" | translate }}</span>
              </mat-option>

              <!-- assign admin -->
              <!--
               rest password => isVerified = true
              ActivateAndSetPassword  isVerified false
                  <mat-option>
                    <span>
                      {{ "Buttons.AssignGlobalAdmin" | translate }}
                    </span>
                  </mat-option> -->

              <!-- resend invitation -->
              <!-- <mat-option *ngIf="!element.isEmailVerified">
                    <span>
                      {{ "Buttons.ResendInvitation" | translate }}
                    </span>
                  </mat-option> -->

              <!-- activate action -->
              <!-- <mat-option
                    *ngIf="element.status !== userStatus.ACTIVE"
                    (click)="onChangeUserStatus(element.id, true)"
                  >
                    <span>
                      {{ "Buttons.Activate" | translate }}
                    </span>
                  </mat-option> -->

              <!-- deactivate action -->
              <!-- <mat-option
                    *ngIf="element.status === userStatus.ACTIVE"
                    (click)="onChangeUserStatus(element.id, false)"
                  >
                    <span>
                      {{ "Buttons.Deactivate" | translate }}
                    </span>
                  </mat-option> -->

              <!-- delete action -->
              <!-- <mat-option (click)="onDeleteUserClicked(element.id)">
                    <span class="delete">
                      {{ "Buttons.Delete" | translate }}
                    </span>
                  </mat-option> -->
            </mat-menu>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="showDetails.emit(row.id)"></tr>
    </table>
  </div>
</app-entity-listing>
